import { render, staticRenderFns } from "./IdentityManage.vue?vue&type=template&id=54382a32&scoped=true&"
import script from "./IdentityManage.vue?vue&type=script&lang=js&"
export * from "./IdentityManage.vue?vue&type=script&lang=js&"
import style0 from "./IdentityManage.vue?vue&type=style&index=0&id=54382a32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54382a32",
  null
  
)

export default component.exports